import { Icon } from "@iconify/react";
import { InputAdornment, TextField } from "@mui/material";
import "./ChatBox.css";

const ChatBox = ({
  placeholder,
  message,
  setMessage,
  handleSendMessage,
  isBroadcast,
  isDisabled,
}) => {
  return (
    <div className="chat-box">
      <TextField
        disabled={isDisabled}
        fullWidth
        placeholder={placeholder}
        value={message}
        InputProps={{
          endAdornment: (
            <InputAdornment
              position="end"
              sx={{ cursor: "pointer" }}
              // Don't trigger send if disabled or message is empty
              onClick={() => !isDisabled && message && handleSendMessage()}
            >
              <Icon
                icon={
                  isBroadcast
                    ? "fluent:megaphone-loud-24-filled"
                    : "ic:outline-send"
                }
                width="26"
              />
            </InputAdornment>
          ),
        }}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={(e) =>
          // Don't trigger send if message is empty
          e.key === "Enter" && message ? handleSendMessage() : ""
        }
      />
    </div>
  );
};

export default ChatBox;
